import * as React from "react";
import { forwardRef, memo } from "react";
const SvgPk = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 120 80", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M0 0h120v80H0z", fill: "#fff" }), /* @__PURE__ */ React.createElement("path", { d: "M30 0h90v80H30z", fill: "#01411c" }), /* @__PURE__ */ React.createElement("circle", { cx: 75, cy: 40, r: 24, fill: "#fff" }), /* @__PURE__ */ React.createElement("circle", { cx: 81.135, cy: 34.547, r: 22, fill: "#01411c" }), /* @__PURE__ */ React.createElement("path", { d: "M83.751 22.041l10.11 11.373L79 30.156l13.94-6.1-7.695 13.129z", fill: "#fff" }));
const ForwardRef = forwardRef(SvgPk);
const Memo = memo(ForwardRef);
export default Memo;
